module.exports = __webpack_public_path__ + "img/default-short.47ab6b3c.jpg";